import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Avatar,
  Card,
  CardContent,
  Grid,
  Typography,
  makeStyles,
  colors
} from '@material-ui/core';
// import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import MoneyIcon from '@material-ui/icons/Money';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%'
  },
  avatar: {
    // backgroundColor: colors.indigo[600],
    backgroundColor: colors.red[600],
    height: 56,
    width: 56
  }
}));

const TotalProfit = ({ className, discountsToday, ...rest }) => {
  const classes = useStyles();

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
          spacing={3}
        >
          <Grid item>
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h6"
            >
              Discounts
            </Typography>
            <Typography
              color="textPrimary"
              variant="h3"
            >
              {discountsToday}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <MoneyIcon />
            </Avatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

TotalProfit.propTypes = {
  className: PropTypes.string,
  discountsToday: PropTypes.string
};

export default TotalProfit;
